module.exports = __webpack_public_path__ + "static/media/caroline.8c3eb6b0.jpg";